import * as React from "react";
import { Icon } from "sb-resp-ui";
const baseClass = "rj-my-pulse-bets__stake-btn";
//export enum Props { plus = "plus", minus = "minus" }
export class StakeButton extends React.Component {
    render() {
        const { isActive, modifier, handler } = this.props;
        const mdf = ` ${baseClass}--${modifier}`;
        return (React.createElement("button", { disabled: isActive, className: `${baseClass}${mdf}`, onClick: handler },
            React.createElement(Icon, { i: `i-14 i-o-pulse-${modifier}` })));
    }
}
//# sourceMappingURL=StakeButton.js.map